import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { pushIf } from "./utils/pushIf";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceZoneCreationNotificationState = createStateReducer(initialState, {
  [events.createZoneSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createZone",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.createZoneFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createZone",
        flags: pushIf({
          invalidName: error.isNameInvalid,
          duplicateZone: error.hasDuplicateName,
          unExpectedError: error.hasUnexpectedError,
        }),
        args: { failure: "true", message: error.message },
      },
      state.queue,
    ),
  }),
});

export { reduceZoneCreationNotificationState };
